<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <h1>Forgot Password</h1>

        <form v-if="!forgotSent" @submit.prevent="performForgot()" class="login-form">
          <div class="form-group mt-4">
            <!-- <label class="control-label" for="email">Email</label> -->
            <label class="control-label" for="email">Please email LevelFi@liftfund.com for password reset and account questions.</label>
            <!-- <input id="email" v-model="email" @blur="$v.email.$touch()" type="email" required="required" class="form-control"> -->
            <div v-if="$v.email.$error" class="val-error">
              <!-- <span v-if="!$v.email.required">Email is required.</span>
              <span v-if="!$v.email.email">Please enter a valid email.</span> -->
              <!-- <span v-if="!$v.email.required">Email is required.</span>
              <span v-if="!$v.email.email">Please enter a valid email.</span> -->
            </div>
          </div>
          <div class="form-group">
            <!-- <button :disabled="$v.$invalid" type="submit" class="btn btn-primary mt-3">Submit</button> -->
          </div>

          <div v-if="passwordFail">
            <p class="bold error-text">There was an error resetting your password</p>
          </div>
        </form>
        <div v-if="forgotSent">
          <p>If that email matches a valid user, an email with password reset instructions will be sent.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import API from "@/services/api";

export default {
  data() {
    return {
      email: "",
      forgotSent: false,
      passwordFail: false
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    async performForgot() {
      this.forgotSent = false;
      this.passwordFail = false;
      try {
        await API.Forgot(this.email);
        this.forgotSent = true;
      } catch (err) {
        this.passwordFail = true;
      }
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue